<template>
  <v-container class="pa-0">
    <v-row>
      <v-col class="pa-0">
        <v-select
          :label="label"
          :items="users"
          v-model="selectedAssigneeId"
          item-value="id"
          item-text="name"
          hide-details
          outlined
          :loading="isFetchingUsers"
          :disabled="isFetchingUsers"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    value: {},
    intervention: {
      type: Object,
      required: true,
    },
    required: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    isFetchingUsers: true,
    errors: [],
    dbUsers: [],
  }),
  computed: {
    selectedAssigneeId: {
      get() { return this.value; },
      set(value) {
        const assignee = _.find(this.dbUsers, { id: value });
        this.$emit(`change`, assignee);

        return this.$emit(`input`, value);
      },
    },
    label() {
      let label = `Utilisateur assigné`;
      if (this.required) {
        label = `${label}*`;
      }

      return label;
    },
    users() {
      return _.chain(this.dbUsers)
        .filter(user => !user.isExcludedFromPlanning)
        .map(user => ({
          ...user,
          name: `${user.firstname} ${user.lastname}`,
        }))
        .value();
    },
  },
  methods: {
    async fetchUsers() {
      this.isFetchingUsers = true;
      this.dbUsers = await this.$store.dispatch(`model/user/fetchForClient`, this.intervention.Maker_id);
      this.isFetchingUsers = false;
    },
  },
  beforeMount() {
    this.fetchUsers();
  },
};
</script>

<style lang="scss">
</style>
